import React, { Component, Fragment } from 'react';
import axios from 'axios';

import Header from '../components/Header';
import BlacklinePost from '../components/BlacklinePost';
import BoxToggle from '../components/BoxToggle';
import parse, { domToReact } from 'html-react-parser';
import Maria from '../imgs/maria.png';

const options = {
  replace: ({ name, children }) => {
    if (!name) {
      return;
    }

    if (name === 'span') {
      return <p>{domToReact(children, options)}</p>;
    }
  },
};

class Home extends Component {
  state = {
    acertarorumo: null,
    visao: null,
    missao: null,
    banner: null,
    isLoading: false,
    allData: null,
    error: [],
    open_presentaion: false,
  };

  setOpenPresentaion = () => {
    this.setState({
      open_presentaion: !this.state.open_presentaion,
    });
  };

  componentDidMount() {
    this.setState({
      isLoading: true,
    });

    Promise.all([
      axios.get('https://www.acertarorumo.pt/wp-json/wp/v2/posts/166'),
      axios.get('https://www.acertarorumo.pt/wp-json/wp/v2/posts/162'),
      axios.get('https://www.acertarorumo.pt/wp-json/wp/v2/posts/164'),
      axios.get('https://www.acertarorumo.pt/wp-json/wp/v2/posts/262'),
      axios.get('https://www.acertarorumo.pt/wp-json/wp/v2/posts/558'),
    ])
      .then(([response1, response2, response3, response4, response5]) => {
        this.setState({
          acertarorumo: response1.data,
          visao: response2.data,
          missao: response3.data,
          banner: response4.data,
          allData: response5.data,
          isLoading: false,
        });
      })
      .catch((error) =>
        this.setState({
          error: error,
          isLoading: false,
        })
      );
  }

  render() {
    const { acertarorumo, isLoading, banner, allData } = this.state;
    console.log('allData: ', allData);
    // console.log(allNews);

    let bannerImg = banner !== null && isLoading === false ? banner.banner_img : '';

    return (
      <Fragment>
        <Header
          title={
            acertarorumo !== null && isLoading === false
              ? acertarorumo.title.rendered
              : 'A carregar...'
          }
          haveImg={!isLoading}
          imgSrc={bannerImg}
        />

        {/* <section className="content blackline" style={{ paddingBottom: '0' }}>
          <div className="column">
            <div
              className="big-text"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  `${
                    acertarorumo !== null && isLoading === false
                      ? acertarorumo.content.rendered
                      : 'A carregar...'
                  }`
                ),
              }}
            />
          </div>
        </section> */}
        {!isLoading && allData !== null && (
          <section className="content " style={{ marginBottom: '0' }}>
            <div className="column ">
              <div className="blackline">
                <h2>Apresentação</h2>
                {this.state.open_presentaion ? (
                  <>
                    <div className="normal-text">
                      {parse(allData.apresentacao_completa, options)}
                    </div>
                    <span className="nobreak hover" onClick={this.setOpenPresentaion}>
                      {' '}
                      [Ler Menos -]
                    </span>
                  </>
                ) : (
                  <>
                    <div className="normal-text">
                      {parse(allData.apresentacao_fechada, options)}
                    </div>
                    <span className="nobreak hover" onClick={this.setOpenPresentaion}>
                      {' '}
                      [Ler Mais +]
                    </span>
                  </>
                )}
              </div>

              <BlacklinePost title={'Plano Curricular'} body={allData.plano_curricular} />

              <div className="blackline">
                <h2>Informação Adicional</h2>

                <BoxToggle
                  title={'Objetivos do curso'}
                  paddBot={true}
                  text_opened={parse(allData.objetivos_do_curso, options)}
                />
                <BoxToggle
                  title={'Admissão'}
                  paddBot={true}
                  text_opened={
                    <>
                      <BoxToggle
                        title={'Documentação Necessária'}
                        paddBot={true}
                        text_opened={parse(allData.documentacao_necessaria, options)}
                      />
                      <BoxToggle
                        title={'Condições de Admissão dos Candidatos'}
                        paddBot={true}
                        text_opened={parse(allData.condicoes_de_admissao_dos_candidatos, options)}
                      />
                      <BoxToggle
                        title={'Critérios de Seriação dos Candidatos'}
                        paddBot={true}
                        text_opened={parse(allData.criterios_de_seriacao_dos_candidatos, options)}
                      />
                      <BoxToggle
                        title={'Outras Informações'}
                        paddBot={true}
                        text_opened={parse(allData.outras_informacoes, options)}
                      />
                      <BoxToggle
                        title={'Reconhecimento da Aprendizagem Prévia'}
                        paddBot={true}
                        text_opened={parse(allData.reconhecimento_da_aprendizagem_previa, options)}
                      />
                      <BoxToggle
                        title={'Montante de Propina/Preço'}
                        paddBot={true}
                        text_opened={parse(allData.montante_de_propinapreco, options)}
                      />
                      <BoxToggle
                        title={'Línguas de Aprendizagem/Avaliação'}
                        paddBot={true}
                        text_opened={parse(allData.linguas_de_aprendizagemavaliacao, options)}
                      />
                      <BoxToggle
                        title={'Enquadramento Legal da Qualificação'}
                        paddBot={true}
                        text_opened={parse(allData.enquadramento_legal_da_qualificacao, options)}
                      />
                    </>
                  }
                />
              </div>
            </div>

            <div className="column">
              <div className="blackline">
                <h2>Informação de Candidaturas</h2>

                <div className="split-two break">
                  <div>
                    <p className="upper-under">Prazos de candidatura</p>
                    {parse(allData.prazos_de_candidatura, options)}
                  </div>
                  <div>
                    <p className="upper-under">Vagas disponíveis</p>
                    {parse(allData.vagas_disponiveis, options)}
                  </div>

                  <div>
                    <p className="upper-under">Submeter Candidatura</p>
                    <div className="split-two" style={{ paddingTop: '0px' }}>
                      <div>
                        <a
                          href="https://inforestudante.uc.pt/nonio/security/login.do"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Estudante UC ↗
                        </a>
                      </div>
                      <div>
                        <a
                          href="https://inforestudante.uc.pt/nonio/security/novoRegisto.do"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Outros ↗
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ paddingTop: '10px' }}>
                  <p className="upper-under">Regime de estudo</p>
                  {parse(allData.regime_de_estudo, options)}
                </div>
              </div>

              <div className="blackline">
                <h2>Coordenação do Curso</h2>
                <div className="split-two break">
                  <div className="split-two">
                    <img src={Maria} alt="img-coordinator" />
                    <span>
                      {' '}
                      <p>Maria José Marcelino</p>
                      <p>Coordenador</p>
                    </span>
                  </div>
                </div>
                <br />
                <div>
                  <span className="upper-under">Email da Coordenação</span>{' '}
                  <span className="hide-mob">—></span> <br className="show-pc" />
                  <a href="mailto:coord-aor@dei.uc.pt">coord-aor@dei.uc.pt</a>
                </div>
              </div>
            </div>
            {/* <div className="column">
    <h2>Valores</h2>
    <p className="normal-text">
      Rigor na seleção. <br />
      Excelência na formação. <br />
      Empregabilidade sustentável.
    </p>
  </div> */}
          </section>
        )}
      </Fragment>
    );
  }
}

export default Home;
